// ----------------------
// AUTHENTICATION
// ----------------------
export const AUTO_PASSWORD = 'AUTO_PASSWORD';
export const CLEAR_AUTH = 'CLEAR_AUTH';
export const AUTH_LOADING = 'AUTH_LOADING';
export const LOG_IN = 'LOG_IN';
export const LOG_OUT = 'LOG_OUT';
export const RESET_LOGIN = 'RESET_LOGIN';
export const TOGGLE_AUTHENTICATION_MODAL = 'TOGGLE_AUTHENTICATION_MODAL';
export const VALIDATE_EMAIL = 'VALIDATE_EMAIL';
export const UPDATE_INSTAGRAM_TOKEN = 'UPDATE_INSTAGRAM_TOKEN';

// ----------------------
// SYSTEM MESSAGE
// ----------------------
export const SET_MESSAGE = 'SET_MESSAGE';
export const CLEAR_MESSAGE = 'CLEAR_MESSAGE';

// ----------------------
// ENTITIES
// ----------------------
export const CLEAR_ENTITIES = 'CLEAR_ENTITIES';
export const CLEAR_ENTITY = 'CLEAR_ENTITY';
export const RECEIVE_ENTITIES = 'RECEIVE_ENTITIES';
export const RECEIVE_ENTITY = 'RECEIVE_ENTITY';

//-----------------------
// SEARCH
//-----------------------
export const SET_SEARCH_ID = 'SET_SEARCH_ID';
export const SET_SEARCH_TERM = 'SET_SEARCH_TERM';
export const SHOW_CREATE = 'SHOW_CREATE';
export const SEARCHING = 'SEARCHING';

//-----------------------
// CUSTOMER
//-----------------------
export const CUSTOMER_LOADED = 'CUSTOMER_LOADED';
export const CUSTOMER_RESOURCE_LOADING = 'CUSTOMER_RESOURCE_LOADING';
export const GET_CUSTOMER_DETAILS = 'GET_CUSTOMER_DETAILS';
export const SET_BUSINESS_LOCATION = 'SET_BUSINESS_LOCATION';
export const LOCATE_CUSTOMER = 'LOCATE_CUSTOMER';
export const RESET_CUSTOMER = 'RESET_CUSTOMER';
export const UPDATE_CUSTOMER_VENDOR = 'UPDATE_CUSTOMER_VENDOR';
export const TOGGLE_USER_MENU = 'TOGGLE_USER_MENU';

///-----------------------
// MERCHANT
//-----------------------
export const REQUEST_CLAIM = 'REQUEST_CLAIM';
export const RESET_MERCHANT = 'RESET_MERCHANT';
export const SET_INVITE_CODE = 'SET_INVITE_CODE';
export const VALIDATE_CLAIM = 'VALIDATE_CLAIM';

//-----------------------
// PLAN --- TODO: REFACTOR TO A MORE GENERALIZED STORE FOR USE THROUGHOUT THE SITE
//-----------------------
export const SAVING_PLAN = 'SAVING_PLAN';
export const SET_PLAN = 'SET_PLAN';
export const SET_ACCOUNT_INFO = 'SET_ACCOUNT_INFO';
export const REPLACE_BUSINESS_INFO = 'REPLACE_BUSINESS_INFO';
export const SET_BUSINESS_INFO = 'SET_BUSINESS_INFO';
export const SET_LOGO = 'SET_LOGO';
export const SET_PHOTOS = 'SET_PHOTOS';
export const SET_INSTAGRAM_PHOTOS = 'SET_INSTAGRAM_PHOTOS';
export const SET_DETAILS = 'SET_DETAILS';
export const SET_STEP = 'SET_STEP';
export const GET_TAGS = 'GET_TAGS';
export const UPDATE_TAGS = 'UPDATE_TAGS';
export const UPDATE_TAGS_EDIT_STATE = 'UPDATE_TAGS_EDIT_STATE';
export const UPDATE_HOURS = 'UPDATE_HOURS';
export const UPDATE_HOURS_EDIT_STATE = 'UPDATE_HOURS_EDIT_STATE';
export const RESET_HOURS_EDIT_STATE = 'RESET_HOURS_EDIT_STATE';
export const RESET_PLAN = 'RESET_PLAN';
export const RESET_TAGS = 'RESET_TAGS';
export const SET_DELETE_IMAGES = 'SET_DELETE_IMAGES';
export const SET_PROFILE_IMAGE = 'SET_PROFILE_IMAGE';

//-----------------------
// SOCIAL 
//-----------------------
export const NEW_POST = 'NEW_POST';
export const LOADING_POST = 'LOADING_POST';
export const TOGGLE_NAV = 'TOGGLE_NAV';



// WEBPACK FOOTER //
// ./src/constants/ActionTypes.js